import addonReducer from './addonReducer';

export * from './addonActions';
export default addonReducer;
